import { executeRequest, Request, Response } from '@jfs/network'
import { isEmpty } from '@jfs/utils'
import { RootStore } from '../data/store'
import { AESEncrypt, generateRandomString, RSAEncrypt } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getBaseUrl, usrSessionRefreshConfig } from './config'

const responseParser = (response: any) => ({
  jfsUserId: response?.jfsUserId,
  refreshToken: response?.session?.refreshToken?.tokenValue,
  identifierToken: response?.session?.identifierToken,
  accessToken: response?.session?.accessToken?.tokenValue,
  accessTokenExpiresIn: response?.session?.accessToken?.expiresIn,
  refreshTokenExpiresIn: response?.session?.refreshToken?.expiresIn,
})

export const pickLocalStorageValue = (val: string, defaultVal: string) => {
  try {
    const sessionData = JSON.parse(localStorage?.getItem('sessionData') ?? '')
    return sessionData[val] ?? defaultVal
  } catch (e) {}
  return defaultVal
}

export const extendUserSession = (emailId: string, storeAccessToken: string, storeRefreshToken: string) => {
  const accessToken = pickLocalStorageValue('usrAccessToken', storeAccessToken)
  const refreshToken = pickLocalStorageValue('usrRefreshToken', storeRefreshToken)
  const appAccessToken = pickLocalStorageValue('appAccessToken', RootStore.session.appAccessToken)
  const appIdToken = pickLocalStorageValue('appIdToken', RootStore.session.appIdToken)
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)

  const request: Request<{}> = {
    apiPath: `${getBaseUrl()}${APIEndPoints.userSessionExtend}`,
    method: 'POST',
    headers: usrSessionRefreshConfig(appAccessToken, appIdToken).headers,
    body: {
      user: {
        mobile: {
          mobileNumber: '1234567890',
          countryCode: '91',
        },
        emailAddress: emailId,
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey,
      },
    },
  }
  return request
}

export const HeaderTransformer = (response: Response, originalRequest?: Request<any>) => {
  console.log('HeaderTransformer ', { response })
  if (response) {
    const { data } = response
    if (
      !isEmpty(data?.session?.accessToken?.tokenValue) &&
      !isEmpty(data?.session?.refreshToken?.tokenValue) &&
      !isEmpty(data?.session?.identifierToken) &&
      !isEmpty(data?.jfsUserId)
    ) {
      const sessionData = responseParser(data)

      RootStore.session.updateUsrSessionData(
        sessionData.accessToken,
        sessionData.refreshToken,
        sessionData.accessTokenExpiresIn,
        sessionData.refreshTokenExpiresIn,
        sessionData.identifierToken,
      )

      if (
        sessionData &&
        originalRequest &&
        sessionData.accessToken &&
        sessionData.identifierToken &&
        originalRequest.headers
      ) {
        originalRequest.headers = {
          ...originalRequest.headers,
          'x-user-access-token': sessionData.accessToken,
          'x-trace-id': generateRandomString(16),
          'x-userid-token': sessionData.identifierToken,
        }
      }
    } else {
      // RootStore.session.updateUserSessionData('', '', '', -1, -1)
      RootStore.session.logout(true)
    }
  }
}

export const extendUserSessionAPI = () => {
  const userEmailId = RootStore?.user?.name
  const sessUsrAccessToken = RootStore?.session?.usrAccessToken
  const sessUsrRefreshToken = RootStore?.session?.usrRefreshToken
  const request = extendUserSession(userEmailId, sessUsrAccessToken, sessUsrRefreshToken)
  return executeRequest(request).then((response) => {
    return HeaderTransformer(response)
  })
}
